import styled, { css } from 'styled-components';

export const ButtonImageVerticalStyled = styled.div<{ disabled?: boolean; selected?: boolean }>`
  .Polaris-ShadowBevel {
    &::before {
      border: ${({ selected }) => (selected ? '1px solid' : 'none')};
    }
    .Polaris-Box {
      :hover {
        background-color: ${({ disabled }) => (disabled ? '#e5e5e5' : '#fafafa')};
      }
      cursor: pointer;
      .custom-card-content,
      .custom-card-header > div {
        display: flex;
        justify-content: center;
        .custom-card-title > div > div:nth-child(2) {
          margin-top: 0;
          font-size: 13px;
          font-weight: bold;
        }
      }
      .card-icon {
        text-align: center;
        border-top: 1px solid #ccc;
      }
      ${({ disabled }) =>
        disabled &&
        css`
          opacity: 0.5;
          cursor: not-allowed;
          background-color: #e5e5e5;
        `}
    }
  }

  &:hover {
    .remove-container {
      display: flex;
    }
  }

  .remove-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    /* display: flex; */
    display: none;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
